// import $ from 'jquery';
// import 'jquery.easing';
// import videojs from 'video.js'
// import "video.js/dist/video-js.css"
// import { Header } from './components/Header.js';
// import { Contact } from './components/Contact.js';
// // import { SearchBox } from './components/SearchBox.js';
// // import { Product } from './components/Product.js';
// // import { Blog } from './components/Blog.js';
// import Slide from './components/Slide.js';
// import Swiper from 'swiper';
// import { Autoplay, EffectCreative } from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/effect-creative';
// import 'swiper/css/navigation';
// import { mediaQuery, scrollTo } from './utils/functions.js';

// mediaQuery();
// const headerInstance = Header();
// Contact();

// Slide();

function requireAll(r){
  r.keys().forEach(r);
}

// const pageHeader = document.querySelector('.lp25-site-wrapper .page-header');
// const lastLookItem = document.querySelector('.lp25-site-wrapper .looks__item:last-child');
// let lastLookItemY = 0;
const pageBody = document.querySelector('body');
const pageWrapper = document.querySelector('.lp25-page-wrapper');
const heroSection = pageWrapper.querySelector('.hero-section');
let windowHeight = window.innerHeight;

const resizeHandler = (e)=>{
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  // get x position of the footer
  // lastLookItemY = lastLookItem.getBoundingClientRect().top + window.scrollY;
  window.dispatchEvent(new Event('scroll'));
  windowHeight = window.innerHeight;
  heroSection.style.width = pageWrapper.offsetWidth + 'px';
}


// scroll to page top
//window.scrollTo(0, 0);

// window.addEventListener("load", function() {
//   window.scrollTo(0, 0);
// });


window.addEventListener('load', resizeHandler);
window.addEventListener('resize', resizeHandler);
// window.addEventListener('scroll', ()=>{
//   // get horizontal scroll position


// });

//check if the device is apple's product
// const isApple = /Mac|iPod|iPhone|iPad/.test(navigator.platform);
// if(!isApple){
//   document.body.classList.add('no-apple');
// }

// make a class for slider
class Slider {
  constructor(elem){
    this.slider = elem;
    this.slides = this.slider.querySelectorAll('.slider__item');
    this.current = 0;
    this.total = this.slides.length;
    this.timer = null;
    this.init();
  }
  init(){
    this.play();
    console.log(this.slides);
  }
  play(){
    this.timer = setInterval(()=>{
      this.next();
    }, 2000);
  }
  next(){
    // this.slides[this.current].classList.remove('active');
    // console.log(this.current);
    // this.current = (this.current + 1) % this.total;
    // // this.slides[this.current - 1].classList.add('next');
    // this.slides[this.current].classList.add('active');
    // this.callback(() => {
    //   //this.slides[this.current - 1].classList.remove('next');
    //   this.slides[this.current].style.zIndex = -this.current;
    //   this.slides[this.current].classList.remove('active');
    // });
    const slide = this.slider.querySelector('.slider__item:last-child');
    slide.classList.add('active');
    this.callback(() => {
      slide.classList.remove('active');
      this.slider.prepend(slide);
    });
  }
  callback(func){
    setTimeout(()=>{
      func();
    }, 1000);
  }
}



const timer = (func, delay)=>{
  setTimeout(()=>{
    func();
  }, delay);
}

// Swiper.use([Autoplay, EffectCreative]);

function applyFadeIn() {
  pageWrapper.classList.remove("loaded");
  timer(() => {
    pageWrapper.classList.add("loaded");
    
    const sliderElems = document.querySelectorAll('.slider');
    sliderElems.forEach((sliderElem) => {
      new Slider(sliderElem);
    });


  }, 1100); // 少し遅延させて適用
  //pageBody.classList.add("lp25-lock");

  timer(()=>{
    window.scrollTo(0, 0);
  }, 1000);

  //timer(() => pageBody.classList.remove("lp25-lock"), 7000);
}

document.addEventListener("DOMContentLoaded", applyFadeIn);
window.addEventListener("load", applyFadeIn);
window.addEventListener("pageshow", function(event) {
  if (event.persisted) {
    applyFadeIn(); // キャッシュ復元時にも実行
  }
});

let st = window.scrollY;
window.addEventListener('scroll', ()=>{
  st = window.scrollY;

  const scrollAmount = windowHeight * 2;

  if(st > scrollAmount){
    pageWrapper.classList.add('scrolled');
  } else {
    pageWrapper.classList.remove('scrolled');
  }


  // let pageHeaderY = Math.min(0, (lastLookItemY - (st)) * 0.3);

  // console.log(pageHeaderY)

  // if(lastLookItemY < st + window.innerHeight){
  //   pageHeader.style.transform = `${pageHeaderY}px`;
  // } else {
  //   pageHeader.style.transform = `${pageHeaderY}px`;
  // }

  // let scrollX = window.scrollX;
  heroSection.style.transform = `translateX(-${scrollX}px)`;

});

// trigger scroll event
window.dispatchEvent(new Event('scroll'));


